export default __webpack_public_path__ + "static/media/P316.2.f8bd81fb.mp3";